import { render } from "./OwnWordsLogo.vue?vue&type=template&id=6124fd26"
import script from "./OwnWordsLogo.vue?vue&type=script&lang=js"
export * from "./OwnWordsLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__